<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--lg">

                    <!-- Header -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-store-2-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                                <p class="cf-modal-head__sub">Tarification par entrepôt</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- Body -->
                    <div class="cf-dialog-body">
                        <div class="space-y-2">
                            <label class="cf-field-label">Entrepôt</label>
                            <div class="cf-select-wrap">
                                <select v-model="selectedlignemagasin" class="cf-inp cf-select">
                                    <option :value="null">Sélectionner un entrepôt</option>
                                    <option v-for="(datavalue, index) of datatable" :key="index" :value="datavalue">{{ datavalue.name }}</option>
                                </select>
                                <i class="ri-arrow-down-s-line cf-select-arrow"></i>
                            </div>
                        </div>

                        <div class="mt-3 grid lg:grid-cols-4 md:grid-cols-2 gap-4">
                            <div class="space-y-2">
                                <label class="cf-field-label">Stock min</label>
                                <input v-model="pppstockminimum" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">Stock max</label>
                                <input v-model="pppstockmaximum" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">Prix de vente</label>
                                <input v-model="pumagasin" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente1 }}</label>
                                <input v-model="pumagasin1" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente2 }}</label>
                                <input v-model="pumagasin2" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente3 }}</label>
                                <input v-model="pumagasin3" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente4 }}</label>
                                <input v-model="pumagasin4" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente5 }}</label>
                                <input v-model="pumagasin5" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente6 }}</label>
                                <input v-model="pumagasin6" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente7 }}</label>
                                <input v-model="pumagasin7" min="0" type="number" class="cf-inp" required>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="cf-dialog-foot">
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                        <button @click="ajouterselectedmagasin" type="button" class="ti-btn ti-btn-primary-full">
                            <i class="ri-add-line align-middle"></i> Ajouter
                        </button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>


    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },
            searchtrierletableau: function(newvalue,oldvalue){

                this.page=1

               // console.log("  oldvalue  searchtrierletableau        **************** ",oldvalue)
               // console.log("  newvalue   searchtrierletableau       **************** ",newvalue)

            }

        },
        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;

               /* if (this.searchtrierletableau!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {

                        return   post.etatcontrat===parseFloat(t.searchtrierletableau)

                    })

                }*/


                if (this.searchword!==''){
                    let t=this;


                    mvalue = mvalue.filter( function (post) {
                        return    post.name.toLowerCase().includes(t.searchword.toLowerCase())
                        /*||
                        post.nameclient.toLowerCase().includes(t.searchword.toLowerCase()) ||
                        post.numbon.toLowerCase().includes(t.searchword.toLowerCase())*/
                    })

                }



                return this.paginate(mvalue) ;
            },
        },
        components: {

            /*appmenu,*/

        },

        data() {
            return {
                isdisplay:false,
                titlemodal:"",
                datatable:[],
                datainputlibelleforms:[],
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                selectedlignemagasin:null,
                puprixdachat:0,
                pumagasin:0,
                pumagasin1:0,
                pumagasin2:0,
                pumagasin3:0,
                pumagasin4:0,
                pumagasin5:0,
                pumagasin6:0,
                pumagasin7:0,
                pppstockminimum:0,
                pppstockmaximum:0,
                addpumagasinprincipal:0,

                jsonarticles:[],
                newsjsonarticles:[],
                createdatapv:[],





                searchword:"",
                searchtrierletableau:"",

                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],
            };
        },
        methods: {


           // ajouterselectedmagasin(value,valuepu,pppstockminimum,pppstockmaximum,pumagasin1,pumagasin2,pumagasin3,pumagasin4,pumagasin5,pumagasin6,pumagasin7){
            ajouterselectedmagasin(){

              /*
                if (this.magasinItem.datajsonarticles.magasin===null ){

                    toastr['error']( "Veuillez sélectionner le magasin principal (Onglet Général)","<b></b>");

                    return
                }

                if (this.magasinItem.datajsonarticles.tarification.prixachat===0 ||
                    this.magasinItem.datajsonarticles.tarification.prixvente===0 ){

                    toastr['error']( "Veuillez saisir le prix d'achat et le prix de vente par défaut (Onglet tarification, Taxe et Tva)","<b></b>");

                    return
                }

                */


                if (this.selectedlignemagasin===null){

                    toastr['error']( 'Veuillez séléctionner un entrepôt',"<b></b>");

                    return
                }


                if (this.pumagasin===0){

                    toastr['error']( 'Veuillez saisir le prix de vente dans ce entrepôt',"<b></b>");

                    return
                }


                let checkexist=0;

                for (let valueanalyse of this.jsonarticles) {


                    if (valueanalyse.mg.pid===this.selectedlignemagasin.pid){
                        checkexist=1;

                        break;
                    }

                }
                if (checkexist===0){
                    for (let valueanalyse of this.newsjsonarticles) {


                        if (valueanalyse.mg.pid===this.selectedlignemagasin.pid){
                            checkexist=1;

                            break;
                        }

                    }
                }



                if (checkexist===0){

                   /* this.jsonarticles.push({
                        'pidligne':'',
                        'mgp':this.selectedlignemagasin.mg,
                        'bd':0,
                        'mg':this.selectedlignemagasin,
                        'pu':this.pumagasin,
                        'pu1':this.pumagasin1,
                        'pu2':this.pumagasin2,
                        'pu3':this.pumagasin3,
                        'pu4':this.pumagasin4,
                        'pu5':this.pumagasin5,
                        'pu6':this.pumagasin6,
                        'pu7':this.pumagasin7,
                        'pv':[],
                        'stockminimum':this.pppstockminimum,
                        'stockmaximum':this.pppstockmaximum,
                        'pa':this.puprixdachat,
                    })
                    this.newsjsonarticles.push({
                        'pidligne':'',
                        'mgp':0,
                        'bd':0,
                        'mg':value,
                        'pu':valuepu,
                        'pu1':pumagasin1,
                        'pu2':pumagasin2,
                        'pu3':pumagasin3,
                        'pu4':pumagasin4,
                        'pu5':pumagasin5,
                        'pu6':pumagasin6,
                        'pu7':pumagasin7,
                        'pv':[],
                        'stockminimum':pppstockminimum,
                        'stockmaximum':pppstockmaximum,
                        'pa':this.puprixdachat,
                    })*/


                    let $value={
                        'pidligne':'',
                        'mgp':this.selectedlignemagasin.mg,
                        'bd':0,
                        'mg':this.selectedlignemagasin,
                        'pu':this.pumagasin,
                        'pu1':this.pumagasin1,
                        'pu2':this.pumagasin2,
                        'pu3':this.pumagasin3,
                        'pu4':this.pumagasin4,
                        'pu5':this.pumagasin5,
                        'pu6':this.pumagasin6,
                        'pu7':this.pumagasin7,
                        'pv':[],
                        'stockminimum':this.pppstockminimum,
                        'stockmaximum':this.pppstockmaximum,
                        'pa':this.puprixdachat,
                    };

                    this.selected("add",$value)



                    /*


                    if (this.addpumagasinprincipal===0){

                        this.jsonarticles.push({
                            'pidligne':'',
                            'mgp':1,
                            'bd':0,
                            'mg':this.magasinItem.datajsonarticles.magasin,
                            'pu':this.magasinItem.datajsonarticles.tarification.prixvente,
                            'pv':this.createdatapv,
                            'pu1':this.magasinItem.datajsonarticles.tarification.prixvente1,
                            'pu2':this.magasinItem.datajsonarticles.tarification.prixvente2,
                            'pu3':this.magasinItem.datajsonarticles.tarification.prixvente3,
                            'pu4':this.magasinItem.datajsonarticles.tarification.prixvente4,
                            'pu5':this.magasinItem.datajsonarticles.tarification.prixvente5,
                            'pu6':this.magasinItem.datajsonarticles.tarification.prixvente6,
                            'pu7':this.magasinItem.datajsonarticles.tarification.prixvente7,
                            'stockminimum':this.magasinItem.datajsonarticles.stockminimum,
                            'stockmaximum':this.magasinItem.datajsonarticles.stockmaximum,
                            'pa':this.magasinItem.datajsonarticles.tarification.prixachat,
                        })
                        this.newsjsonarticles.push({
                            'pidligne':'',
                            'mgp':1,
                            'bd':0,
                            'stockminimum':this.magasinItem.datajsonarticles.stockminimum,
                            'stockmaximum':this.magasinItem.datajsonarticles.stockmaximum,
                            'mg':this.magasinItem.datajsonarticles.magasin,
                            'pu':this.magasinItem.datajsonarticles.tarification.prixvente,
                            'pu1':this.magasinItem.datajsonarticles.tarification.prixvente1,
                            'pu2':this.magasinItem.datajsonarticles.tarification.prixvente2,
                            'pu3':this.magasinItem.datajsonarticles.tarification.prixvente3,
                            'pu4':this.magasinItem.datajsonarticles.tarification.prixvente4,
                            'pu5':this.magasinItem.datajsonarticles.tarification.prixvente5,
                            'pu6':this.magasinItem.datajsonarticles.tarification.prixvente6,
                            'pu7':this.magasinItem.datajsonarticles.tarification.prixvente7,
                            'pa':this.magasinItem.datajsonarticles.tarification.prixachat,
                            'pv':this.createdatapv,
                        })
                        this.addpumagasinprincipal=1;
                    }

                    */





                }
                else{          toastr['error']( 'Cet entrepôt avait été sélectionné',"<b></b>");}








            },



            close(){

                this.isdisplay=false;

                //this.$emit('closed');

            },

            selected(option,datavalue){



                this.selectedlignemagasin=null
                this.pumagasin=0
                this.pumagasin1=0
                this.pumagasin2=0
                this.pumagasin3=0
                this.pumagasin4=0
                this.pumagasin5=0
                this.pumagasin6=0
                this.pumagasin7=0
                this.pppstockminimum=0
                this.pppstockmaximum=0

                // Suppose que vous avez un objet représentant l'élément sélectionné
                const elementSelectionne = { typ:option, value: datavalue};

                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('elementSelectionnetarificationstock', elementSelectionne);


                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;
            },

            show(titlemodal,listdata,datainputlibelleforms,puprixdachat,jsonarticles,newsjsonarticles){
                this.messagesucces="";
                this.messageerror="";
                this.titlemodal=titlemodal
                this.puprixdachat=puprixdachat
                this.jsonarticles=jsonarticles
                this.newsjsonarticles=newsjsonarticles
                this.datatable=listdata
                this.datainputlibelleforms=datainputlibelleforms

                this.selectedlignemagasin=null
                this.pumagasin=0
                this.pumagasin1=0
                this.pumagasin2=0
                this.pumagasin3=0
                this.pumagasin4=0
                this.pumagasin5=0
                this.pumagasin6=0
                this.pumagasin7=0
                this.pppstockminimum=0
                this.pppstockmaximum=0


                this.isdisplay=true;

            },






            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--lg { max-width:820px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.cf-field-label { display:block; font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:600; color:var(--cf-muted); margin-bottom:6px; }
.cf-inp { width:100%; height:40px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color 0.2s, box-shadow 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-select-wrap { position:relative; }
.cf-select { appearance:none; padding-right:28px; cursor:pointer; }
.cf-select-arrow { position:absolute; right:10px; top:50%; transform:translateY(-50%); color:var(--cf-faint); pointer-events:none; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--lg { max-width:100%; } }
</style>
